import { countDistinctApprovers, hasEmptyStep, hasHumanApprover } from './approvalStepsUtils';

// The maximum number of distinct approvers allowed across the ENTIRE approval
// (not per stage). Single source of truth shared by the request modal, the
// reassign modal, and the settings template builder.
export const MAX_APPROVERS = 10;

// The maximum number of stages allowed in a single approval process. Single
// source of truth shared by the request modal, the reassign modal, and the
// settings template builder.
export const MAX_STAGES = 10;
/**
 * Centralized "is this a valid approval process" check, shared across the
 * request, reassign, and template flows so they agree on the common core rules:
 * at least one human approver, no empty stage, at least one approver, and no
 * more than MAX_APPROVERS distinct approvers total. Each flow layers its own
 * extra constraints (e.g. reassign's already-approved rules) on top.
 */
export const validateApprovalProcess = steps => {
  const distinctApproverCount = countDistinctApprovers(steps);
  const humanApprover = hasHumanApprover(steps);
  const emptyStep = hasEmptyStep(steps);
  const exceedsMaxApprovers = distinctApproverCount > MAX_APPROVERS;
  return {
    hasHumanApprover: humanApprover,
    hasEmptyStep: emptyStep,
    distinctApproverCount,
    exceedsMaxApprovers,
    isAtMaxApprovers: distinctApproverCount >= MAX_APPROVERS,
    isAtMaxStages: steps.length >= MAX_STAGES,
    isValid: distinctApproverCount > 0 && humanApprover && !emptyStep && !exceedsMaxApprovers
  };
};